<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Curiosidades</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="curiosity">Curiosidades</label>
                                    <select name="curiosity[]" id="curiosity" v-model="ordered" size="8" mulcuriosityle>
                                        <option :value="index" v-for="(curiosity, index) in curiosity">
                                            {{ curiosity.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setCuriosities">Ordenar Curiosidades <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(curiosity,index) in selected' :key="curiosity.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + curiosity.id">{{ index + 1 }}. {{ curiosity.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(curiosity, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                curiosity: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getCuriositiesArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getCuriosities: function(){
                let self = this;
                let api  = self.$store.state.api + 'curiosity?paginated=false';
                let curiosity = $('#curiosity');

                self.$http.get(api)
                    .then((response) => {
                        self.curiosity = response.data.data;
                        self.ordered  = self.getCuriositiesArray(self.curiosity);
                    })
                    .then(() => {
                        curiosity.bootstrapDualListbox();
                        curiosity.ready(function () {
                            curiosity.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Promotional Materials', 'error');
                    });
            },
            setCuriosities: function(){
                const self   = this;
                let curiosity = self.selected;

                $('#curiosity').find(':selected').each(function(){
                    curiosity.push(self.curiosity[$(this).val()]);
                });

                self.selected = curiosity;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/curiosity", self.getCuriositiesArray);
            },
            remove: function(curiosity, index){
                const self = this;
                const api  = self.$store.state.api + 'curiosity/' + curiosity.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getCuriosities();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CuriosityOrder/Index.vue